module.exports = __webpack_public_path__ + "img/about_con_1-1.48c8e452.png";